const submenuItems = [
  {
    header: 'Types of Life Insurance',
    items: [
      { title: 'Term Life Insurance', url: '/life-insurance/term-life-insurance/', },
      { title: 'Level Term Life Insurance', url: '/life-insurance/level-term-life-insurance/', },
      { title: 'Return of Premium Life Insurance', url: '/life-insurance/return-of-premium-life-insurance/', },
      { title: 'No Medical Exam Life Insurance', url: '/life-insurance/no-medical-exam-life-insurance/', },
      { title: 'Whole Life Insurance', url: '/life-insurance/whole-life-insurance/', },
    ]
  },
  {
    header: 'Helpful Resources',
    items: [
      { title: 'Life Insurance Advice', url: '/life-insurance/learn/', },
      { title: 'Life Insurance Calculator', url: '/life-insurance/life-insurance-calculator/', },
      { title: 'Best Life Insurance Companies', url: '/life-insurance/best-life-insurance-companies/', },
      { title: 'Term vs. Whole Life Insurance', url: '/life-insurance/learn/whole-life-versus-term-life-insurance/', },
      { title: 'Life Insurance Shopping Guide', url: '/life-insurance/learn/shopping-advice/', },
    ]
  },
  {
    header: 'Life Insurance Company Reviews',
    items: [
      { title: 'Banner Life', url: '/life-insurance/reviews/banner-life/', },
      { title: 'Lincoln Financial', url: '/life-insurance/reviews/lincoln-financial/', },
      { title: 'Pacific Life', url: '/life-insurance/reviews/pacific-life/', },
      { title: 'Prudential', url: '/life-insurance/reviews/prudential/', },
      { title: 'View All Companies', url: '/life-insurance/reviews/', },
    ]
  },
];

export default {
  menu: {
    header: 'Life Insurance',
    shortHeader: 'Life',
    link: '/life-insurance/',
    activeName: 'life-insurance',
    columns: 3,
  },
  intro: {
    cta: 'Get a Free Quote',
    icon: 'lifeColor3X',
    linkHref: '/life-insurance/',
    secondaryLinkHref: '/life-insurance/learn/',
  },
  list: {
    key: 'life-submenu-list-',
    items: submenuItems,
    type: 'links',
  }
};



// WEBPACK FOOTER //
// ../src/templates/MainNav/data/products/lifeData.js